import React from "react";
import { GeneralStore } from "../core/GeneralStore";

export class BaseComponent<P, S> extends React.Component<P, S> {
  generalStore = new GeneralStore();

}
